var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvailableAiTokens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_83)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_210_83)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 30,
    fill: "#C04483"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 27,
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2389 23.5226C34.4493 23.5226 34.5546 23.3998 34.6072 23.207C35.1508 20.2784 35.1157 20.2083 38.167 19.6295C38.3774 19.5945 38.5002 19.4717 38.5002 19.2613C38.5002 19.0509 38.3774 18.9281 38.167 18.893C35.1333 18.2793 35.2209 18.2091 34.6072 15.3157C34.5546 15.1228 34.4493 15 34.2389 15C34.0285 15 33.9233 15.1228 33.8707 15.3157C33.2569 18.2091 33.3621 18.2793 30.3108 18.893C30.1179 18.9281 29.9776 19.0509 29.9776 19.2613C29.9776 19.4717 30.1179 19.5945 30.3108 19.6295C33.3621 20.2434 33.327 20.2784 33.8707 23.207C33.9233 23.3998 34.0285 23.5226 34.2389 23.5226ZM25.7515 35.5875C26.0846 35.5875 26.3126 35.377 26.3476 35.0614C26.979 30.3792 27.1368 30.3792 31.9768 29.4499C32.2925 29.3972 32.5204 29.1868 32.5204 28.8536C32.5204 28.5379 32.2925 28.31 31.9768 28.2574C27.1368 27.591 26.9614 27.4331 26.3476 22.6633C26.3126 22.3477 26.0846 22.1197 25.7515 22.1197C25.4358 22.1197 25.2078 22.3477 25.1727 22.6809C24.5941 27.3805 24.3485 27.363 19.5436 28.2574C19.228 28.3275 19 28.5379 19 28.8536C19 29.2043 19.228 29.3972 19.6138 29.4499C24.3836 30.2214 24.5941 30.3442 25.1727 35.0263C25.2078 35.377 25.4358 35.5875 25.7515 35.5875ZM37.641 55C38.0969 55 38.4301 54.6668 38.5177 54.1934C39.7628 44.5835 41.1131 43.128 50.6177 42.0758C51.1087 42.0232 51.4419 41.6549 51.4419 41.1991C51.4419 40.7431 51.1087 40.3923 50.6177 40.3222C41.1131 39.27 39.7628 37.8145 38.5177 28.2048C38.4301 27.7313 38.0969 27.4156 37.641 27.4156C37.185 27.4156 36.8518 27.7313 36.7817 28.2048C35.5366 37.8145 34.1688 39.27 24.6817 40.3222C24.1732 40.3923 23.84 40.7431 23.84 41.1991C23.84 41.6549 24.1732 42.0232 24.6817 42.0758C34.1512 43.3209 35.4664 44.6011 36.7817 54.1934C36.8518 54.6668 37.185 55 37.641 55Z",
    fill: "white",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_210_83",
    x: 0,
    y: 2,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_210_83"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_83"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_83",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableAiTokens);
export default __webpack_public_path__ + "static/media/available-ai-tokens.40922ff53e3b0de42371aeb11b4bc556.svg";
export { ForwardRef as ReactComponent };